var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      class: { "has-notification": _vm.hasNotification },
      attrs: { id: "wrapper" },
    },
    [
      _c("div", {
        staticClass: "top-notification-bar",
        class: {
          "danger text-white": _vm.notificationData["status"] === "danger",
          warning: _vm.notificationData["status"] === "warning",
        },
        domProps: { innerHTML: _vm._s(_vm.notificationData["msg"]) },
        on: { click: _vm.handleNotificationClick },
      }),
      _c("Topbar", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !_vm.blockedScreen,
            expression: "!blockedScreen",
          },
        ],
        attrs: { "is-menu-opened": _vm.showMobileMenu },
      }),
      _vm.user
        ? _c("SideBar", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: !_vm.blockedScreen,
                expression: "!blockedScreen",
              },
            ],
          })
        : _vm._e(),
      _c(
        "div",
        {
          staticClass: "content-page",
          class: { "blocked-screen": _vm.blockedScreen },
        },
        [
          _c(
            "div",
            { staticClass: "content", staticStyle: { "margin-top": "10px" } },
            [
              _c(
                "div",
                { staticClass: "container-fluid" },
                [_c("router-view")],
                1
              ),
            ]
          ),
        ]
      ),
      _vm.user && _vm.user.total_credits > 0 && _vm.user.remaining_credits <= 0
        ? _c(
            "b-modal",
            {
              attrs: { "hide-footer": true, title: "Plan Limit Reached" },
              on: { hide: _vm.hideModal },
              model: {
                value: _vm.showOverLimitModal,
                callback: function ($$v) {
                  _vm.showOverLimitModal = $$v
                },
                expression: "showOverLimitModal",
              },
            },
            [
              _vm._v(
                " You’ve reached your limit on text-to-speech or cloned voice allocation. Upgrade your plan now to unlock additional usage and keep creating amazing content with Clip Cast. "
              ),
              _c(
                "router-link",
                {
                  staticClass: "btn btn-dark-blue rounded-0 d-block mt-3",
                  attrs: { to: { name: "agency.subscription" } },
                  on: { click: _vm.hideModal },
                },
                [_vm._v("Upgrade Plan Now")]
              ),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }